module.exports = __webpack_public_path__ + "img/smile_icon_white.4dfd093c.svg";